/** №16 S4 — the small line glyphs the run surfaces reuse (no emoji; D-DS rules). */
export const TickGlyph = ({ w = 9 }: { w?: number }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={3} style={{ width: w, height: w }}><path d="M20 6 9 17l-5-5" /></svg>
);
export const PencilGlyph = ({ w = 12 }: { w?: number }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} style={{ width: w, height: w }}><path d="M12 20h9M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" /></svg>
);
export const ClockGlyph = ({ w = 11 }: { w?: number }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} style={{ width: w, height: w }}><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
);
export const ForkGlyph = ({ w = 12 }: { w?: number }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} style={{ width: w, height: w }}><path d="M6 21V9m0 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm12 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 0v1a4 4 0 0 1-4 4H6" /></svg>
);
